export enum UserIdType {
  Mobile = 'mobile',
  Email = 'email',
  Username = 'user_name'
}


export const isCidaasSystemUserId = (loginMethod: string): boolean => {
  switch (loginMethod.toLowerCase()) {
    case UserIdType.Email:
    case UserIdType.Mobile:
    case UserIdType.Username:
      return true;
  }
  return false;
};

export const loginMethodToQuery = (loginMethod: string): string => {
  if (isCidaasSystemUserId(loginMethod)) {
    return loginMethod.toLowerCase();
  }
  return  loginMethod;
};


// Cidaas provider related helpers


interface CidaasProvider {
  displayName: string;
  iconClass: string;

}

// Add in new system providers if added, ensure that icons.scss has an icon entry with pattern
// cidaas-icon-{{provider-name}}
enum CidaasSystemProvider {
  Amazon= 'amazon',
  Google = 'google',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Twitter = 'twitter',
  Youtube = 'youtube',
  Vimeo = 'vimeo',
  Flickr = 'flickr',
  Dribble = 'dribbble',
  Behance = 'behance',
  Steam = 'steam',
  DropBox = 'dropbox',
  OneDrive = 'onedrive',
  Github = 'github',
  NPM = 'npm',
  WordPress = 'wordpress',
  Yahoo = 'yahoo',
  Apple = 'apple',
  Android = 'android',
  Microsoft = 'microsoft',
  Skype = 'skype',
  LinkedIn = 'linkedin',
  StackOverflow = 'stackoverflow',
  Paypal = 'paypal',
  PaypalSandbox = 'paypal_sandbox',

  NetId = 'netid',
  NetIdQA = 'netid_qa',

  OfficeEnterprise = 'officeenterprise',
  Office365 = 'office-365',
  Office = 'office',

  Chrome = 'chrome',
  Firefox = 'firefox',
  InternetExplorer = 'ie',
  Edge = 'edge',
  Safari = 'safari',
  Opera = 'opera'

}

export const SystemProvidersValues = Object.keys(CidaasSystemProvider).map(key => CidaasSystemProvider[key] as CidaasSystemProvider);

type SystemProvidersMap = { [key: string]: CidaasProvider };


const createIconClass = (displayName: string): string => `cidaas-icon-${displayName}`;

const createCidaasProviderByName = (displayName: string): CidaasProvider => {
  return {
    displayName,
    iconClass: createIconClass(displayName)
  };
};

const createCidaasProviderBySystemProvider = (provider: CidaasSystemProvider): CidaasProvider => {
  return provider !== 'netid_qa' && createCidaasProviderByName(provider)
    || {
      displayName:  'netid qa',
      iconClass: createIconClass('netid'),
    };
};

const generateSystemProvidersMap = (providers: CidaasSystemProvider[]): SystemProvidersMap => {
  return providers.reduce((previousValue, currentValue) => {
    return {
      ...previousValue,
      [currentValue]: createCidaasProviderBySystemProvider(currentValue)
    };
  }, {} as SystemProvidersMap);
};


const SupportedSystemLoginProviders: { [key: string]: CidaasProvider } = generateSystemProvidersMap(SystemProvidersValues);

export const getIconForProvider = (displayName: string): string => {
  return SupportedSystemLoginProviders[displayName]?.iconClass || 'cidaas-icon-provider';
};


